/**
 * Props comuns para modais fullscreen no mobile/PWA.
 * Usa a classe .mobile-fullscreen-modal (theme.css) com layout flex —
 * header/footer fixos, body com scroll. Não usar bodyStyle com calc(100dvh - Npx).
 */

/** Popup de Select/DatePicker/AutoComplete dentro do body rolável do modal/sheet. */
export function modalPopupContainer(triggerNode) {
  if (!triggerNode) return document.body;
  return (
    triggerNode.closest('.mobile-launch-sheet__body') ||
    triggerNode.closest('.ant-modal-body') ||
    triggerNode.closest('.ant-drawer-body') ||
    document.body
  );
}

/** Mantém o campo visível acima do teclado no body do modal/sheet. */
export function scrollFieldIntoView(event) {
  const target = event?.target;
  if (!target || typeof target.closest !== 'function') return;
  const body =
    target.closest('.mobile-launch-sheet__body') ||
    target.closest('.ant-modal-body');
  if (!body) return;
  // Aguarda o teclado/vvh ajustar antes de centralizar
  requestAnimationFrame(() => {
    setTimeout(() => {
      try {
        target.scrollIntoView({ block: 'center', behavior: 'smooth', inline: 'nearest' });
      } catch {
        target.scrollIntoView(true);
      }
    }, 80);
  });
}

export const getMobileFullscreenModalProps = (isMobile) =>
  isMobile
    ? {
        width: '100%',
        wrapClassName: 'mobile-fullscreen-modal',
        style: { top: 0, margin: 0, maxWidth: '100%' },
        styles: {
          body: { WebkitOverflowScrolling: 'touch' },
        },
      }
    : {};
